"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _UsersStyled = require("./Users-styled.js");
var _UserItem = _interopRequireDefault(require("../UserItem"));
var _UserSearch = _interopRequireDefault(require("../UserSearch"));
var _helper = require("../../utils/helper");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Users = function Users(_ref) {
  var users = _ref.users,
    userSession = _ref.userSession,
    onUserItemClick = _ref.onUserItemClick,
    addUser = _ref.addUser,
    portal = _ref.portal,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? true : _ref$label,
    _ref$marginBottom = _ref.marginBottom,
    marginBottom = _ref$marginBottom === void 0 ? false : _ref$marginBottom;
  var handleUserSearchChange = function handleUserSearchChange(user) {
    addUser(user);
  };
  var handleUserClick = function handleUserClick(activeUser) {
    onUserItemClick(activeUser.id);
    addUser(activeUser);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_UsersStyled.StyledUsers, {
    selectable: true,
    marginBottom: marginBottom
  }, label && /*#__PURE__*/_react.default.createElement(_UsersStyled.StyledUsersHeader, null, typeof label == "string" ? label : "Users"), /*#__PURE__*/_react.default.createElement(_UsersStyled.StyledUsersSearchWrapper, {
    filterItem: true
  }, /*#__PURE__*/_react.default.createElement(_UserSearch.default, {
    userSession: userSession,
    onChange: handleUserSearchChange
  })), /*#__PURE__*/_react.default.createElement(_UsersStyled.StyledUserItemsWrapper, null, users.items.allIds.map(function (id, index) {
    return /*#__PURE__*/_react.default.createElement(_UserItem.default, {
      key: (0, _helper.createAccountKey)({
        username: id,
        portalName: portal === null || portal === void 0 ? void 0 : portal.name
      }),
      item: users.items.byId[id],
      primary: index === 0,
      onClick: function onClick() {
        handleUserClick(users.items.byId[id]);
      }
    });
  }))));
};
var _default = Users;
exports.default = _default;